"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
class PendingAssociationQuote {
    constructor(obj) {
        this.farm_id = obj.farm_id || -1;
        this.farm_name = obj.farm_name || '';
        this.preferred_unit = obj.preferred_unit || '';
        this.farm_extension = obj.farm_extension || 0;
        this.farm_gis_fields_total = obj.farm_gis_fields_total || 0;
        this.gis_area_id = obj.gis_area_id || -1;
        this.quote_id = obj.quote_id || -1;
        this.quoted_gis_fields = obj.quoted_gis_fields || 0;
        this.quote_extension = obj.quote_extension || 0;
        this.geodata = obj.geodata || '';
        this.crops = obj.crops.map((c) => new Crop_1.default(c)) || [];
    }
    get cropColor() {
        var _a, _b;
        if (this.crops) {
            if (((_a = this.crops) === null || _a === void 0 ? void 0 : _a.length) === 1) {
                return this.crops[0].color;
            }
            else if (((_b = this.crops) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                return '#2A7346';
            }
            else {
                return '#AAA9A9';
            }
        }
        else {
            return '#AAA9A9';
        }
    }
}
exports.default = PendingAssociationQuote;
